var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBabyShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C35.3137 20 38 22.6863 38 26C38 29.3137 35.3137 32 32 32C28.6863 32 26 29.3137 26 26C26 22.6863 28.6863 20 32 20Z",
    fill: "#4D9DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 44H20C20 39.5817 23.5817 36 28 36H36C40.4183 36 44 39.5817 44 44Z",
    fill: "#4D9DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L20 20M40 24L44 20M32 16V12",
    stroke: "#4D9DFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyShower);
export default __webpack_public_path__ + "static/media/baby-shower.7ed63b6d1365f63c26b07bc8f6fc4335.svg";
export { ForwardRef as ReactComponent };